import React, { useState } from 'react';
import '../styles/AdminPanel.css';

function AdminPanel() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === 'vinland123') { // Simple password
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password');
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <div className="login-form">
          <h2>Admin Access</h2>
          <form onSubmit={handleLogin}>
            <input
              type="password"
              placeholder="Enter admin password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit">Login</button>
          </form>
          <p className="hint">Hint: vinland123</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <h1>Admin Panel</h1>
      <div className="admin-sections">
        <div className="admin-card">
          <h3>Manage Collections</h3>
          <p>Add, edit, or delete photo collections</p>
          <button>Manage Collections</button>
        </div>
        <div className="admin-card">
          <h3>Upload Photos</h3>
          <p>Add new photos to existing collections</p>
          <button>Upload Photos</button>
        </div>
        <div className="admin-card">
          <h3>Site Settings</h3>
          <p>Update hero image, logo, and site content</p>
          <button>Site Settings</button>
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;
